import { useCallback, useState } from 'react';
import { dataAttrGUI } from '@at/formatter-utils/lib/data-attr-utils/data-attr-utils';
import { usePrefersReducedMotion } from '@at/hooks/lib/use-prefers-reduced-motion/use-prefers-reduced-motion';
export var useCarouselMovement = function (_a) {
    var totalSlides = _a.totalSlides, loopScroll = _a.loopScroll, elementRef = _a.elementRef, uniqueId = _a.uniqueId, trackingOnScrollCallback = _a.trackingOnScrollCallback;
    var _b = useState(0), currentSlideIndex = _b[0], setCurrentSlideIndex = _b[1];
    var prefersReducedMotion = usePrefersReducedMotion();
    var trackSlideByIndex = useCallback(function (slideIndex) {
        trackingOnScrollCallback === null || trackingOnScrollCallback === void 0 ? void 0 : trackingOnScrollCallback(slideIndex);
    }, [trackingOnScrollCallback]);
    var handleSlideChange = useCallback(function (slideIndex) {
        var _a;
        var slide = (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("[".concat(dataAttrGUI, "=").concat("".concat(uniqueId, "-slide-").concat(slideIndex), "]"));
        if (!slide)
            return;
        slide === null || slide === void 0 ? void 0 : slide.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            // NOTE: - 'nearest' seems the most reliable option
            block: 'nearest',
            inline: 'nearest',
        });
    }, [elementRef, uniqueId, prefersReducedMotion]);
    var finalSlideIndex = totalSlides - 1;
    var isOnFinalSlide = currentSlideIndex === finalSlideIndex;
    var isOnFirstSlide = currentSlideIndex === 0;
    var handleSlideStateChange = useCallback(function (newSlideIndex) {
        setCurrentSlideIndex(newSlideIndex);
        trackSlideByIndex(newSlideIndex);
        requestAnimationFrame(function () { return handleSlideChange(newSlideIndex); });
    }, [handleSlideChange, trackSlideByIndex]);
    var handleLoopScroll = useCallback(function (requestedIndex) {
        // Go back to the first slide
        if (requestedIndex >= finalSlideIndex && isOnFinalSlide) {
            var newSlideIndex_1 = 0;
            handleSlideStateChange(newSlideIndex_1);
            return;
        }
        // Go to the last slide
        if (requestedIndex <= 0 && isOnFirstSlide) {
            var newSlideIndex_2 = totalSlides - 1;
            handleSlideStateChange(newSlideIndex_2);
            return;
        }
        var newSlideIndex = requestedIndex;
        handleSlideStateChange(newSlideIndex);
    }, [finalSlideIndex, isOnFinalSlide, isOnFirstSlide, totalSlides, handleSlideStateChange]);
    var handleRegularScroll = useCallback(function (requestedIndex) {
        var direction = requestedIndex > currentSlideIndex ? 'next' : 'previous';
        if (direction === 'next' && isOnFinalSlide)
            return;
        if (direction === 'previous' && isOnFirstSlide)
            return;
        var newSlideIndex = requestedIndex;
        handleSlideStateChange(newSlideIndex);
    }, [currentSlideIndex, isOnFinalSlide, isOnFirstSlide, handleSlideStateChange]);
    var handleSlideMove = useCallback(function (requestedSlideIndex) {
        if (loopScroll) {
            handleLoopScroll(requestedSlideIndex);
            return;
        }
        handleRegularScroll(requestedSlideIndex);
    }, [loopScroll, handleLoopScroll, handleRegularScroll]);
    var shouldDisablePreviousButton = isOnFirstSlide && !loopScroll;
    var shouldDisableNextButton = isOnFinalSlide && !loopScroll;
    return {
        handleSlideMove: handleSlideMove,
        currentSlideIndex: currentSlideIndex,
        totalSlides: totalSlides,
        shouldDisableNextButton: shouldDisableNextButton,
        shouldDisablePreviousButton: shouldDisablePreviousButton,
        isOnFirstSlide: isOnFirstSlide,
        isOnFinalSlide: isOnFinalSlide,
    };
};
